import { appData } from '@/mocks/home';

export default function AppSection() {
  const { title, description, features, image } = appData;

  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
              {title}
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
              {description}
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-2 md:gap-3">
              {features.map((f, i) => (
                <span
                  key={i}
                  className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-medium whitespace-nowrap"
                >
                  <i className="ri-check-line w-3 h-3 flex items-center justify-center"></i>
                  {f}
                </span>
              ))}
            </div>
          </div>
          <div className="flex-1 max-w-xs lg:max-w-sm">
            <div className="rounded-lg overflow-hidden">
              <img
                src={image}
                alt="随时随地畅享观影"
                className="w-full h-auto object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}